// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__13nXp","bigColWidth":"Table_bigColWidth__13d_S","biggerColWidth":"Table_biggerColWidth__1-H4I","row":"Table_row__oU6E9","col":"Table_col__2s56W"};